export default __webpack_public_path__ + "static/media/Octopus.7ae177bc.png";